var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#55ACEE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#5F787E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.528 10.833h16.666a2.09 2.09 0 0 1 2.084 2.083v12.5a2.09 2.09 0 0 1-2.084 2.084H11.528a2.09 2.09 0 0 1-2.084-2.084l.01-12.5a2.08 2.08 0 0 1 2.074-2.083Zm8.885 9.031 7.364-4.604a.885.885 0 1 0-.938-1.5l-6.978 4.365-6.98-4.365a.885.885 0 1 0-.937 1.5l7.365 4.604c.333.209.77.209 1.104 0Z",
    fill: "#fff"
  })));
};
export default SvgMail;